module.exports = __webpack_public_path__ + "img/Logo Payoo_Logo Payoo blanc.698b877a.png";